export const enum CannedResponseEvent {
  CannedResponseSaved = 'Canned response saved',
  CannedResponseUpdated = 'Canned response edited',
  CannedResponseUsed = 'Canned response used',
  CannedResponseCopied = 'Canned response copied',
}
